import { ColumnApi, GetContextMenuItemsParams, GridApi, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import { BaseDatasource } from '@/shared/resources/datasources/base-datasource'
import { AgColumnDefinition, AgGridOptions, defaultModeViewAgGrid, IModeView } from '@/shared/models/ag-grid.model'
import { StrictNullable } from '@/shared/types/app.types'
import { CommonFilterModel } from '@/api/resources/common/shared/models/common.models'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'

export interface ViewOptions {
    modeView: IModeView
}

export interface BaseCrud {
    getContextMenuItems(params: GetContextMenuItemsParams): (string | MenuItemDef)[]
    activateDeactivateSelection?(option: boolean, selectionBatch: any): any
    createOperation?(params: any): any
    patchOperation?(params: any): any
    deleteOperation?(params: any): any
    deleteBatchOperation?(params: any): any
}

export interface CrudModelBase<R, D extends BaseDatasource<R> = BaseDatasource<R>> {
    actionTitle?: string
    gridOptions: AgGridOptions
    gridUiComponent: string
    selectedRows: R[]
    clickedRow?: StrictNullable<R>
    columnsDef?: AgColumnDefinition[]
    gridApi: StrictNullable<GridApi>
    columnApi: StrictNullable<ColumnApi>
    datasource: StrictNullable<D>
    rowData?: R[]
    visibleSidePanel?: boolean
    viewOptions: ViewOptions
    filterModel?: StrictNullable<CommonFilterModel>
}
export type CrudModelPaginator<R, D extends PaginatorDatasource<R> = PaginatorDatasource<R>> = CrudModelBase<R, D>
export type CrudModelPaginatorLaboratory<R, D extends PaginatorLaboratoryDatasource<R> = PaginatorLaboratoryDatasource<R>> = CrudModelPaginator<R, D>

export function initialCrudModelBaseState<R, D extends BaseDatasource<R> = BaseDatasource<R>>(): CrudModelBase<R, D> {
    return {
        actionTitle: '',
        gridOptions: {},
        gridUiComponent: '',
        selectedRows: [],
        clickedRow: null,
        columnsDef: [],
        gridApi: null,
        columnApi: null,
        datasource: null,
        rowData: [],
        viewOptions: {
            modeView: { ...defaultModeViewAgGrid }
        },
        visibleSidePanel: false,
        filterModel: null
    }
}
